import { UI_PERMISSION } from "@/core/utils/access/permissionConstants"
import { useFeatureFlag } from "@/hooks/useFeatureFlag"
import usePermissions from "@/hooks/userPermission"

export const useEasyRxModuleAccess = (): boolean => {
  const isFlagEnabled = useFeatureFlag("enable-easyrx-module")
  const { hasAny } = usePermissions()
  return isFlagEnabled && hasAny(UI_PERMISSION.UI_MODULE_EASYRX)
}
